export default "__VITE_ASSET__CIzW5Y43__"